import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";

import { Button } from "components/Button";
import { BillingMobileCardContainer } from "./HistoryMobileCard.styles";

const SubscribedStrategyMobileCard = ({ subscription, handleUnSubscribe }) => {
  return (
    <BillingMobileCardContainer>
      <div className="header">
        <Row>
          <Col sm={6} xs={6}>
            <div className="strategy-name">
              <div className="title">Name</div>
              <div className="value">{subscription.strategy_name}</div>
            </div>
          </Col>
          <Col sm={6} xs={6}>
            <Button
              width="100%"
              className="btn-unsubscribe"
              onClick={() => handleUnSubscribe(subscription.strategy_id)}
            >
              Unsubscribe
            </Button>
          </Col>
        </Row>
      </div>
      <div className="details-wrapper">
        <table>
          <thead>
            <tr>
              <th>Price</th>
              <th>Plan</th>
              <th>Status</th>
              <th>Purchase Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{subscription.price}</td>
              <td>{subscription.plan || "-"}</td>
              <td>{subscription.license_status}</td>
              <td>{subscription.purchase_date}</td>
            </tr>
          </tbody>
        </table>
        <div className="divider"></div>
      </div>
    </BillingMobileCardContainer>
  );
};

SubscribedStrategyMobileCard.propTypes = {
  subscription: PropTypes.object,
  handleUnSubscribe: PropTypes.func,
};

export default SubscribedStrategyMobileCard;
